import { h } from '@stencil/core';
export class MobileFiltersCategories {
  constructor() {
    this.categories = undefined;
  }
  render() {
    var _a, _b;
    if (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) === 0)
      return;
    return (h("ul", { class: "mobile-filters-categories" }, (_b = this.categories) === null || _b === void 0 ? void 0 : _b.map((i) => (h("li", { class: "mobile-filters-categories__item" }, h("a", { class: "mobile-filters-categories__button", onClick: () => {
        this.selectCategory.emit(i.navigationState);
      } }, h("span", null, i.label)))))));
  }
  static get is() { return "pes-mobile-filters-categories"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["mobile-filters-categories.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["mobile-filters-categories.css"]
    };
  }
  static get properties() {
    return {
      "categories": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TFiltersCategory[]",
          "resolved": "TFiltersCategory[]",
          "references": {
            "TFiltersCategory": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Array of information for each category."
        }
      }
    };
  }
  static get events() {
    return [{
        "method": "selectCategory",
        "name": "selectCategory",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event emitted when a category item is clicked."
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
